import $ from "jquery";
import {Fancybox} from "@fancyapps/ui";

import InView from "./components/InView";
import Form from "./components/Form";
import StageManager from "./components/StageManager";

document.addEventListener("DOMContentLoaded", (event) => {
    new StageManager();
    new InView();
    new Form();

    $('[data-fancybox]').fancybox({
        gutter: 20
    });
});
